export class ProperCaseValueConverter {
    toView(value: string) {
        return !!value ? value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase() : '';
    }
}
